<script lang="ts" setup>
const model = defineModel<any>();

const props = withDefaults(
  defineProps<{
    label?: string;
    inlineLabel?: string;
    rules?: any[];
    placeholder?: string;
    type?: string;
    hideDetails?: boolean | 'auto';
    width?: string | number;
    prependInnerIcon?: string;
    requiredMark?: boolean;
    min?: any;
    max?: any;
    disabled?: boolean;
    hint?: string;
    readonly?: boolean;
    autocomplete?: string;
    tooltip?: string;
    step?: number;
    maxWidth?: string | number;
    minWidth?: string | number;
    counter?: boolean | number | string;
    suffix?: string;
  }>(),
  {
    hideDetails: 'auto',
  },
);

// A password field shows an eye icon so that the user can check what they typed.
const isPassword = computed(() => props.type === 'password');
const showPassword = ref(false);
</script>

<template>
  <div
    :style="{ width, minWidth, maxWidth }"
    :data-suge-field="label || inlineLabel || undefined"
    :data-suge-required="requiredMark || undefined"
  >
    <m-input-label
      :text="label"
      :required-mark="requiredMark"
      :tooltip="tooltip"
    />

    <v-text-field
      v-model="model"
      :rules="rules"
      variant="outlined"
      dense
      validate-on="blur"
      :type="isPassword && showPassword ? 'text' : type"
      :min="min"
      :max="max"
      :placeholder="placeholder"
      :hide-details="hideDetails"
      :label="inlineLabel"
      :width="width"
      :max-width="maxWidth"
      :min-width="minWidth"
      :hint="hint"
      :readonly="readonly"
      :prepend-inner-icon="prependInnerIcon"
      :disabled="disabled"
      :autocomplete="autocomplete"
      :step="step"
      :counter="counter"
      :suffix="suffix"
      :append-inner-icon="isPassword ? (showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline') : undefined"
      @click:append-inner="showPassword = !showPassword"
    />
  </div>
</template>
